// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UiContainerInputsNormal_wrapper__3efrx"};